// The subject a page's title names, shared by the server-rendered head
// (`server-seo.ts`) and the SPA's `document.title` on every navigation. Both
// compose it with `composeTitle` from `seo-text.ts`. Two tables would drift,
// and GA4 records whichever string the tab carries: a page whose first load
// and in-app arrival disagree reports as two pages.

import { pageSection } from './page-sections';

// Search titles for the indexable public pages, matched by exact path only so
// a page beneath one keeps its section's label (`/circles` is titled for
// search; `/circles/{id}/members` stays "Circles"). These are what a searcher
// reads in a result, so they name what the page offers rather than repeating
// a nav label, and they lead with the words a searcher scans for. Each
// subject fits 42 characters, which keeps the brand suffix inside the 60
// character title budget (`composeTitle`). Google may substitute the page's
// heading when the two disagree, so a page whose heading is its name (the
// policies) is titled by that same name.
const PUBLIC_PAGE_SUBJECTS: Readonly<Record<string, string>> = Object.freeze({
  '/': 'Free Circles, Networks & Career Resources',
  '/circles': 'Browse Lean In Circles Near You or Online',
  '/networks': 'Find a Lean In Network by City or Industry',
  '/resources': 'Free Career and Leadership Resources',
  '/join': 'Join Free: Career Resources and Community',
  '/start-a-circle': 'Start a Free Lean In Circle',
  '/join-a-circle': 'Join a Free Lean In Circle',
  '/join-a-network': 'Join a Free Lean In Network',
  '/help': 'Help and Support',
});

// The subject a page is titled by when its route supplies none of its own:
// the public page's search title, else its section.
export function pageSubject(pathname: string): string | null {
  return Object.hasOwn(PUBLIC_PAGE_SUBJECTS, pathname)
    ? PUBLIC_PAGE_SUBJECTS[pathname]!
    : (pageSection(pathname)?.subject ?? null);
}
